import React, { FC, ReactNode } from 'react';
import { Trans } from 'react-i18next';
import { Button, Grid, Paper, Typography } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';

import { FeedKey, GetGroupFollowersDocument, Group } from 'api';
import { FollowToggle, GroupAvatar } from 'components';

import Tabs from './Tabs';

interface IProps {
  group: Group;
  isFollowing: boolean;
  menu: ReactNode;
}

interface IPropsEnhanced extends IProps, WithStyles<typeof styles> {}

const styles = ({ custom, spacing }: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    block: {
      width: spacing(2),
      height: spacing(2),
      marginLeft: spacing(1),
      marginRight: spacing(1),
      borderRadius: '50%',
    },
    container: {
      borderBottom: `1px solid ${custom.palette.grey3}`,
    },
    lastItem: {
      marginRight: 12,
    },
  });

const DesktopBanner: FC<IPropsEnhanced> = props => {
  const { classes, group, isFollowing, menu } = props;

  const backgroundColor = group.color_map.hex;

  function renderToggle() {
    return (
      <FollowToggle
        source={group}
        type={FeedKey.Group}
        refetchQueries={[
          { query: GetGroupFollowersDocument, variables: { id: group.id, limit: 10 } },
        ]}>
        {({ onClick }) => (
          <Button size="small" color="secondary" variant="contained" onClick={onClick}>
            <Trans i18nKey="common:join" />
          </Button>
        )}
      </FollowToggle>
    );
  }

  function renderTopRow() {
    return (
      <Grid container alignItems="center">
        <Grid item>
          <GroupAvatar square group={group} size={48} />
        </Grid>
        <Grid item>
          <div className={classes.block} style={{ backgroundColor }} />
        </Grid>
        <Grid item xs zeroMinWidth>
          <Typography color="textPrimary" variant="subtitle2" noWrap>
            {group.title}
          </Typography>
        </Grid>
        <Grid item className={classes.lastItem}>
          {renderToggle()}
        </Grid>
      </Grid>
    );
  }

  if (isFollowing) {
    return (
      <Paper>
        <Grid container alignItems="center" justify="space-between">
          <Grid item>
            <Tabs group={group} />
          </Grid>
          <Grid item>{menu}</Grid>
        </Grid>
      </Paper>
    );
  }

  return (
    <Paper className={classes.root}>
      <Grid className={classes.container} container alignItems="center">
        <Grid item xs>
          {renderTopRow()}
        </Grid>
      </Grid>
      <Grid container>
        <Grid item>
          <Tabs group={group} />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default withStyles(styles)(DesktopBanner);
